var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"withus"},[_c('div',{staticClass:"bg"},[_c('video',{staticClass:"video",attrs:{"src":require('@/assets/video/bg2.mp4'),"autoplay":"","loop":"","muted":""},domProps:{"muted":true}})]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"title"},[_vm._v("一起推动您的品牌发展")]),_c('div',{staticClass:"btn"},[_vm._v("联系我们")])])
}]

export { render, staticRenderFns }